import { useMemo, type CSSProperties } from "react";
import { range, rand } from "../utils/random";
import type { EffectProps } from "./types";

export function CherryBlossoms({ count = 40 }: EffectProps = {}) {
  const petals = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        left: `${rand(0, 100)}vw`,
        scale: rand(0.7, 1.3),
        fallDuration: `${rand(8, 15)}s`,
        spinDuration: `${rand(4, 9)}s`,
        delay: `${rand(-15, 0)}s`,
        opacity: rand(0.55, 0.9),
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {petals.map(p => (
        <span
          key={p.id}
          className="fx-particle fx-petal"
          style={
            {
              left: p.left,
              top: 0,
              scale: `${p.scale}`,
              opacity: p.opacity,
              animationDuration: `${p.fallDuration}, ${p.spinDuration}`,
              animationDelay: `${p.delay}, ${p.delay}`,
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}
